import React from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import './ProfessionalInfo.css';
import Swal from 'sweetalert2';

function FabricatorPipeFitterFields({ formData, updateField }) {
    // Helper function for single-select fields to allow unselecting
    const toggleSingleField = (field, value) => {
        const newValue = formData[field] === value ? null : value;
        updateField(field, newValue);
    };

    // Helper functions for multi-select fields (with max 4 limit for technical_skills)
    const toggleArrayField = (field, item, maxLimit = null) => {
        const currentArray = formData[field] || [];
        const safeArray = Array.isArray(currentArray) ? currentArray : [currentArray];

        if (safeArray.includes(item)) {
            updateField(field, safeArray.filter(i => i !== item));
        } else {
            if (maxLimit && safeArray.length >= maxLimit) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Limit Reached',
                    text: `You can select a maximum of ${maxLimit} options.`,
                    confirmButtonColor: '#0d6efd'
                });
                return;
            }
            updateField(field, [...safeArray, item]);
        }
    };

    // Industry options
    const industries = [
        "Oil & Gas", "Petrochemical", "Refinery",
        "Power Plant", "Construction", "Shipyard"
    ];

    // Technical Skills options
    const technicalSkillsOptions = [
        "Read Isometric Drawings", "Interpret P&ID", "Pipe Spool Fabrication",
        "Pipe Cutting & Beveling", "Fit-up & Alignment", "Hydro Testing",
        "Bolt Torque Knowledge", "CS / SS / Alloy Pipe Work",
        "Structural Fabrication", "Fabrication as per Drawing", "Other"
    ];

    // Tools & Equipment Knowledge
    const toolsKnowledgeOptions = [
        "Grinding Machine", "Gas Cutting", "Threading Machine",
        "Pipe Bending Machine", "Measuring Tools", "Tack Welding Knowledge"
    ];

    return (
        <>
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Industry Details *</h4>
                <Row className="g-3 mb-3">
                    {industries.map((industry, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.industry === industry ? 'selected-button' : ''}`}
                                onClick={() => {
                                    if (formData.industry === industry) {
                                        updateField('industry', null);
                                    } else {
                                        updateField('industry', industry);
                                        updateField('other_industry', '');
                                    }
                                }}
                            >
                                {industry}
                            </Button>
                        </Col>
                    ))}
                    <Col xs={12}>
                        <Form.Control
                            type="text"
                            placeholder="Other (Type here)"
                            className="jobtype-btn w-100 h-100 text-center"
                            style={{
                                backgroundColor: formData.industry === 'Other' ? '#0d6efd' : '#f8f9fa',
                                color: formData.industry === 'Other' ? 'white' : 'black',
                                border: 'none'
                            }}
                            value={formData.other_industry || ''}
                            onChange={(e) => {
                                updateField('industry', 'Other');
                                updateField('other_industry', e.target.value);
                            }}
                            onClick={() => {
                                if (formData.industry !== 'Other') {
                                    updateField('industry', 'Other');
                                }
                            }}
                        />
                    </Col>
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">
                    Technical Skills
                    <span className="ms-2 text-muted" style={{ fontSize: '14px', fontWeight: 'normal' }}>
                        (Max 4 options)
                    </span>
                </h4>
                <Row className="g-3 mb-4">
                    {technicalSkillsOptions.map((skill, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.fabricator_technical_skills?.includes(skill) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('fabricator_technical_skills', skill, 4)}
                            >
                                {skill}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Tools & Equipment Knowledge</h4>
                <Row className="g-3 mb-4">
                    {toolsKnowledgeOptions.map((tool, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${formData.fabricator_tools_knowledge?.includes(tool) ? 'selected-button' : ''}`}
                                onClick={() => toggleArrayField('fabricator_tools_knowledge', tool)}
                            >
                                {tool}
                            </Button>
                        </Col>
                    ))}
                </Row>
            </div>
        </>
    );
}

export default FabricatorPipeFitterFields;
